import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Settings/Views/settings.html";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import EmailSetting from "@/Pages/Admin/Modules/Settings/Email/Controllers/EmailSetting";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

@WithRender
@Component({
  components: {
    EmailSetting,
  },
})
export default class AllSettings extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected isError: boolean = false;
  protected RequestList: any = [];
  protected ApprovedTypeList: any = [];
  protected SearchBy: any = {};
  protected allSelected: boolean = false;
  constructor() {
    super();
    this.ui.IsLoading = false;
    this.ui.PostLoading = false;
  }
  // public mounted() {
  //   this.getAccountRequest();
  // }
  // public getAccountRequest() {
  //   // console.log("HELLO !!! from All Settings");
  // }
}
